if(!customElements.get('tips-expandable')) {
  class ComponentTipsExpandable extends HTMLElement {
    constructor() {
      super();
      this.carousel = this.querySelector('.component-carousel');
      this.keenSlider = this.querySelector('.keen-slider');
      var mqS = window.matchMedia("(max-width: "+window.breakpoints.medium+")");
      var isMobile = false;

      var infoElements = this.querySelectorAll('.info');

      setTimeout(()=>{ //The timeout is for the customizer
        $s.resizeWidthHandle(()=>{

         
          if(mqS.matches){

            if(!isMobile) 
            {
              this.carousel.initSlider();
            }
          }
          else{
            if(isMobile)
              this.carousel.removeSlider();
            
          }

          if(mqS.matches){
            setTimeout(() => {
              var highValue = 0;
              infoElements.forEach( elem => {

                if(highValue < elem.scrollHeight)
                  highValue = elem.scrollHeight;

              })

              var mediaWrap = this.querySelector('.active .media-wrap');

              this.keenSlider.style.height = highValue + 26 + mediaWrap.offsetHeight + 'px';
            },200)

          }

         


          isMobile = mqS.matches;
        });
      }, 1);

    }



  }
  customElements.define('tips-expandable', ComponentTipsExpandable);
}